import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface AppliancesProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Appliances: React.FC<AppliancesProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [appliances, set_appliances] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Interior Finishes']?.['Appliances'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior Finishes': { ...b.values?.['Interior Finishes'], 'Appliances': v } } })
    );
    const label = 'Appliances';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(appliances)}
                />
            ) : (
                <MoneyBox
                    id={'appliances'}
                    allowNegative={false}
                    value={appliances}
                    onChange={(value) => set_appliances(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
